export class AssetOpExport {
    assetinvNo1: string;
    assetinvNo2: string;
    costCenterCode: string;
    costCenterName: string;
    quantity: number;
    modifiedAt: Date;
}